import { GetClubesAccesoInvitado } from "../../../../reducers/invitados";

export interface TabAccesosStore extends GetClubesAccesoInvitado {}

export const tabAccesosStore: (state) => TabAccesosStore = state => {
  const { invitados } = state;

  return {
    clubesAccesoInvitado: invitados.clubesAccesoInvitado,
    gettingClubesAccesoInvitado: invitados.gettingClubesAccesoInvitado,
    gettingClubesAccesoInvitadoError: invitados.gettingClubesAccesoInvitadoError
  };
};
